import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	isLoading: false,
	status: "",
	message: "",
};

const LoginSlice = createSlice({
	name: "login",
	initialState,
	reducers: {
		requestPending: state => {
			state.isLoading = true;
		},
		stopSpinner: state => {
			state.isLoading = false;
		},
		requestFail: (state, { payload }) => {
			state.isLoading = false;
			state.status = "error";
			state.message = payload;
		},
	},
});

const { reducer, actions } = LoginSlice;
export const { requestPending, stopSpinner, requestFail } = actions;

export default reducer;
